export const VEHICLE_BY_ID = (id) => `v2/machines/${id}`;
export const REALESTATES_BY_ID = (id) => `v2/real-estates/${id}`;
export const VEHICLE = `v2/machines`;
export const REALESTATES = `v2/real-estates`;
